// extracted by mini-css-extract-plugin
module.exports = {"calTitleCustom":"RegistrationFree_calTitleCustom__1IO64"};